import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { SearchResultsCommand } from '../../../core/commands/search-results.command';
import { Country } from '../../../core/models/country.model';
import { SearchResultsRepository } from '../../../core/repositories/search-result.repository';

@Component({
  selector: 'lib-search-bar',
  templateUrl: './search-bar.component.html',
  styleUrls: ['./search-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SearchBarComponent implements OnInit {
  @Input() form: UntypedFormGroup;
  @Input() countries: Country[];

  @Output() doSearch = new EventEmitter<unknown>();

  isLoading$: Observable<boolean>;

  constructor(
    private searchResultsCommand: SearchResultsCommand,
    private searchResultsRepository: SearchResultsRepository,
  ) {}

  ngOnInit() {
    this.isLoading$ = this.searchResultsRepository.isSearching$;
  }

  onSubmit() {
    this.searchResultsCommand.updateIsSearching(true);
    this.doSearch.emit();
  }
}
